import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
    '../components',
    true,
    /[A-Z]\w+\.(vue|js)$/,
)

requireComponent.keys().forEach(filename => {
    const component = requireComponent(filename)
    const name = upperFirst(camelCase(

        // @ts-ignore
        filename
            .split('/')
            .pop()
            .replace(/\.\w+$/, ''),
    ))

    Vue.component(name, component.default || component)
})
